const LOATypeEnum = Object.freeze({
    APPLICATION: 'APPLICATION', // Application form-based LOAs
    INVESTOR_LOA: 'INVESTOR_LOA', // An LOA generated for a specific investor
    OTHER: 'OTHER' // Some other document being used as an LOA
});

export default LOATypeEnum;
